const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M328.417,208.293l-40-80c-2.541-5.082-7.735-8.292-13.417-8.292c-5.682,0-10.875,3.21-13.416,8.292 l-44.868,89.735L158.98,69.565c-2.181-5.609-7.503-9.371-13.519-9.557c-6.006-0.173-11.559,3.243-14.081,8.708L75.402,190.001H15 c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15h70c5.851,0,11.168-3.402,13.619-8.714l45.201-97.934l57.2,147.085 c2.15,5.53,7.358,9.273,13.285,9.547c0.233,0.011,0.466,0.016,0.699,0.016c5.659,0,10.864-3.194,13.413-8.292L275,168.542 l26.584,53.167c3.705,7.41,12.716,10.414,20.124,6.708C329.118,224.713,332.121,215.703,328.417,208.293z"
});

const SvgPulse = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-pulse",
    viewBox: "0 0 330.003 330.003",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPulse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pulse.7215b022.svg";
export { ForwardRef as ReactComponent };